import React, { FCWithChildren } from 'react';
import styles from './static-pages-layout.module.scss';

// This layout providers tag-based styling for static pages
const StaticPagesLayout: FCWithChildren = (props) => {
  const { children } = props;

  return <main className={styles.staticPages}>{children}</main>;
};

export default StaticPagesLayout;
